import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiBuilding, BiStore, BiCog, BiSolidEnvelope } from "react-icons/bi";
import Link from 'next/link';

const ItConsultingIndustries = () => {
    const { t } = useTranslations();

    const industries = [
        {
            icon: BiBuilding,
            title: t("itConsulting_industries_production_title"),
            description: t("itConsulting_industries_production_description"),
            color: "#59bd65",
            solutions: [
                t("itConsulting_industries_production_solutions_1"),
                t("itConsulting_industries_production_solutions_2"),
                t("itConsulting_industries_production_solutions_3"),
                t("itConsulting_industries_production_solutions_4")
            ]
        },
        {
            icon: BiStore,
            title: t("itConsulting_industries_commerce_title"),
            description: t("itConsulting_industries_commerce_description"),
            color: "#45a049",
            solutions: [
                t("itConsulting_industries_commerce_solutions_1"),
                t("itConsulting_industries_commerce_solutions_2"),
                t("itConsulting_industries_commerce_solutions_3"),
                t("itConsulting_industries_commerce_solutions_4")
            ]
        },
        {
            icon: BiCog,
            title: t("itConsulting_industries_services_title"),
            description: t("itConsulting_industries_services_description"),
            color: "#1B5E20",
            solutions: [
                t("itConsulting_industries_services_solutions_1"),
                t("itConsulting_industries_services_solutions_2"),
                t("itConsulting_industries_services_solutions_3"),
                t("itConsulting_industries_services_solutions_4")
            ]
        }
    ];

    return (
        <section className="ptb-100 it-consulting-industries">
            {/* Hintergrund-Dekoration */}
            <div className="it-consulting-industries__decoration it-consulting-industries__decoration--top-left"></div>
            <div className="it-consulting-industries__decoration it-consulting-industries__decoration--bottom-right"></div>

            <div className="container">
                <div className="section-title text-center it-consulting-industries__header">
                    <h2 className="it-consulting-industries__title">
                        {t("itConsulting_industries_title")}
                        <span className="it-consulting-industries__title-underline"></span>
                    </h2>
                    <p className="it-consulting-industries__description">
                        {t("itConsulting_industries_description")}
                    </p>
                </div>

                <div className="row">
                    {industries.map((industry, index) => {
                        const IconComponent = industry.icon;
                        return (
                            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                <div className="it-consulting-industries__card">
                                    {/* Icon */}
                                    <div 
                                        className="it-consulting-industries__icon-wrapper"
                                        style={{ 
                                            background: `linear-gradient(135deg, ${industry.color}, ${industry.color}dd)`,
                                            boxShadow: `0 10px 30px ${industry.color}30`
                                        }}
                                    >
                                        <IconComponent className="it-consulting-industries__icon" />
                                    </div>

                                    {/* Titel */}
                                    <h3 className="it-consulting-industries__card-title">
                                        {industry.title}
                                    </h3>

                                    {/* Beschreibung */}
                                    <p className="it-consulting-industries__card-description">
                                        {industry.description}
                                    </p>

                                    {/* Lösungen */}
                                    <div className="it-consulting-industries__solutions">
                                        <h4 className="it-consulting-industries__solutions-title">
                                            {t("itConsulting_industries_solutions_title")}
                                        </h4>
                                        {industry.solutions.map((solution, solutionIndex) => (
                                            <div key={solutionIndex} className="it-consulting-industries__solution-item">
                                                <div 
                                                    className="it-consulting-industries__solution-dot"
                                                    style={{ background: industry.color }}
                                                ></div>
                                                {solution}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Zusätzliche Informationen */}
                <div className="row mt-5">
                    <div className="col-lg-10 mx-auto">
                        <div className="it-consulting-industries__cta-box">
                            <h3 className="it-consulting-industries__cta-title">
                                {t("itConsulting_industries_contact_title")}
                            </h3>
                            <p className="it-consulting-industries__cta-description">
                                {t("itConsulting_industries_contact_description")}
                            </p>
                            <Link href="/kontakt" className="it-consulting-industries__cta-btn">
                                <BiSolidEnvelope /> {t("itConsulting_industries_contact_button")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ItConsultingIndustries;
